export default function (_ref) {
  var store = _ref.store,
      redirect = _ref.redirect;

  if (store.getters.isAuth !== null || store.getters.isAuth !== false) {
    return redirect('/');
  }
}


//////////////////
// WEBPACK FOOTER
// ./middleware/logged.js
// module id = ./middleware/logged.js
// module chunks = 152